import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Rating,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";

const Form = ({ form }) => {
  const { register, control } = form;
  const { t } = useTranslation();

  return (
    <>
      <TextField
        margin="normal"
        label={t("author")}
        fullWidth
        required
        {...register("author", { required: true, maxLength: 20 })}
      />
      <TextField
        margin="normal"
        label={t("product-name")}
        fullWidth
        required
        {...register("name", { required: true })}
      />
      <FormControl margin="normal" fullWidth>
        <Controller
          name="score"
          control={control}
          rules={{ required: true }}
          defaultValue={0}
          render={({ field }) => <Rating precision={0.5} {...field} />}
        />
      </FormControl>
      <FormControl margin="normal" fullWidth>
        <FormControlLabel
          control={
            <Controller
              name="incomplete"
              control={control}
              render={({ field }) => <Checkbox {...field} />}
            />
          }
          label={t("incomplete")}
          labelPlacement="end"
        />
      </FormControl>
      <TextField
        type="number"
        margin="normal"
        label={t("word-count")}
        fullWidth
        {...register("wordCount", { required: true, min: 1 })}
      />
      <TextField
        margin="normal"
        label={t("intro")}
        multiline
        rows={4}
        fullWidth
        {...register("content")}
      />
      <TextField
        margin="normal"
        label={t("tags")}
        fullWidth
        {...register("tags")}
      />
    </>
  );
};

export default Form;
